import { z } from "zod";
import {
  TITLE,
  DATE,
  YEAR,
  TYPE,
  COMPANY,
  UPLOAD,
  DESCRIPTION,
} from "./consts";

export const addSchema = z.object({
  [TITLE]: z.string().min(1, "This field is required"),
  [DATE]: z.string().min(1, "This field is required"),
  [YEAR]: z.string().optional(),
  [TYPE]: z.string().min(1, "This field is required"),
  [COMPANY]: z.string().min(1, "This field is required"),
  [UPLOAD]: z.any(),
  [DESCRIPTION]: z.string().min(1, "This field is required"),
});

export type AddModelFormValues = z.infer<typeof addSchema>;
